module.exports = __webpack_public_path__ + "img/155-credit-card.c1183601.svg";